import { NgModule } from '@angular/core';
import { SizeNotifierDirective } from './directives/size-notifier.directive';
import { FocusOnLoadDirective } from './directives/focus-on-load.directive';
import { DisableButtonDirective } from './directives/disable-button.directive';
import { NullDefaultValueDirective } from './directives/reset-to-null.directive';
import { CasingPipe } from './pipes/casing.pipe';
import { CustomDateTimePipe } from './pipes/custom-date-time.pipe';
import { CustomDatePipe } from './pipes/custom-date.pipe';
import { DefaultValuePipe } from './pipes/default-value.pipe';
import { FilterPipe } from './pipes/filter.pipe';
import {
  FormControlShouldShowValidationPipe,
  FormControlShouldShowValidationForError,
  FormControlShouldShowWarning
} from './pipes/form-control-should-show-validation.pipe';
import { FormControlPipe } from './pipes/form-control.pipe';
import { RecordNamePipe } from './pipes/record-name.pipe';
import { ReplaceSpaceWithDash } from './pipes/replace-space-with-dash.pipe';
import { SplitPascalCasePipe } from './pipes/split-pascal-case.pipe';
import { TableComponent } from './components/table/table/table.component';
import { PagingComponent } from './components/table/paging/paging.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatRadioModule } from '@angular/material/radio';
import { RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';

const components = [TableComponent, PagingComponent];

const directives = [SizeNotifierDirective, FocusOnLoadDirective, DisableButtonDirective, NullDefaultValueDirective];

const pipes = [
  CustomDatePipe,
  CustomDateTimePipe,
  DefaultValuePipe,
  FormControlShouldShowValidationPipe,
  FormControlShouldShowValidationForError,
  FormControlShouldShowWarning,
  FormControlPipe,
  CasingPipe,
  SplitPascalCasePipe,
  FilterPipe,
  ReplaceSpaceWithDash,
  RecordNamePipe
];

const imports = [
  CommonModule,
  FormsModule,
  ReactiveFormsModule,
  RouterModule,
  NgbModule,
  NgSelectModule,
  MatRadioModule,
  MatExpansionModule
];

@NgModule({
  declarations: [...components, ...directives, ...pipes],
  exports: [...components, ...directives, ...pipes],
  imports: [...imports]
})
export class SharedModule {}
